export const measures = [
  {
    unitCode: "page_views",
    unitName: "页面浏览量",
    belongDimName: null,
  },
  {
    unitCode: "click_count",
    unitName: "点击次数",
    belongDimName: null,
  },
  {
    unitCode: "duration",
    unitName: "停留时长",
    belongDimName: null,
  },
  {
    unitCode: "bounce_rate",
    unitName: "跳出率",
    belongDimName: null,
  },
];

export const dimensions = [
  // 时间维度
  {
    unitCode: "behavior_date",
    unitName: "行为日期",
    belongDimName: null,
  },
  {
    unitCode: "behavior_hour",
    unitName: "行为小时",
    belongDimName: null,
  },
  // 行为维度
  {
    unitCode: "behavior_type",
    unitName: "行为类型",
    belongDimName: null,
  },
  {
    unitCode: "page_type",
    unitName: "页面类型",
    belongDimName: null,
  },
  {
    unitCode: "device_type",
    unitName: "设备类型",
    belongDimName: null,
  },
  // 用户维度
  {
    unitCode: "user_segment",
    unitName: "用户细分",
    belongDimName: null,
  },
  {
    unitCode: "user_level",
    unitName: "用户等级",
    belongDimName: null,
  },
  // 退化维度
  {
    unitCode: "user_id",
    unitName: "用户ID",
    belongDimName: null,
  },
  {
    unitCode: "session_id",
    unitName: "会话ID",
    belongDimName: null,
  },
];

export const tableWidgets = {
  type: "Table",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "交叉表",
  defaultCols: "whole",
  className: "component-type-cross-table",
  defaultImg: "http://172.31.29.180:3000/static/img/table-none.ca8daa.png",
  measures,
  dimensions,
  fields: [
    {
      label: "行/维度",
      isMust: false,
      limitNum: null,
      type: "dimension",
      alias: "dimension",
      queryType: "rows",
      chooseFields: [
        {
          unitCode: "user_level",
          unitName: "用户等级",
          belongDimName: null,
          id: "user_level_1",
          name: "用户等级",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
        {
          unitCode: "behavior_date",
          unitName: "行为日期",
          belongDimName: null,
          id: "behavior_date_0",
          name: "行为日期",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
        {
          unitCode: "behavior_type",
          unitName: "行为类型",
          belongDimName: null,
          id: "behavior_type_2",
          name: "行为类型",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
      ],
    },
    {
      label: "列/维度/度量",
      isMust: false,
      limitNum: null,
      type: "any",
      alias: "measure",
      queryType: "columns",
      chooseFields: [
        {
          unitCode: "page_views",
          unitName: "页面浏览量",
          belongDimName: null,
          id: "page_views_1",
          name: "页面浏览量",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "any",
          alias: "measure",
          queryType: "columns",
        },
      ],
    },
  ],
  styleComp: {
    type: "c-table-style",
    styleConfig: {},
  },
  _id: "id_1757502661965",
  dataSetId: "USER_BEHAVIOR_FACT",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    fields: {
      rows: ["user_segment", "user_level"],
      columns: [],
      values: ["page_views", "click_count", "duration", "bounce_rate"],
      valueInCols: true,
    },
    meta: [
      {
        field: "page_views",
        name: "页面浏览量",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
      {
        field: "duration",
        name: "停留时长",
      },
      {
        field: "bounce_rate",
        name: "跳出率",
      },
      {
        field: "behavior_date",
        name: "行为日期",
      },
      {
        field: "user_segment",
        name: "用户分群",
      },
      {
        field: "user_level",
        name: "用户等级",
      },
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "device_type",
        name: "设备类型",
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
      },
      {
        page_views: 1350,
        click_count: 380,
        duration: 220.7,
        bounce_rate: 0.12,
        behavior_date: "2023-01-20",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 1680,
        click_count: 520,
        duration: 280.4,
        bounce_rate: 0.09,
        behavior_date: "2023-01-21",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "移动端",
      },
      {
        page_views: 1120,
        click_count: 340,
        duration: 195.2,
        bounce_rate: 0.21,
        behavior_date: "2023-01-22",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "平板",
      },
      {
        page_views: 1980,
        click_count: 620,
        duration: 310.8,
        bounce_rate: 0.07,
        behavior_date: "2023-01-23",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1450,
        click_count: 410,
        duration: 240.6,
        bounce_rate: 0.14,
        behavior_date: "2023-01-24",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
      },
      {
        page_views: 820,
        click_count: 260,
        duration: 155.9,
        bounce_rate: 0.19,
        behavior_date: "2023-01-25",
        user_segment: "老用户",
        user_level: "普通",
        behavior_type: "搜索",
        device_type: "平板",
      },
      {
        page_views: 1750,
        click_count: 580,
        duration: 295.3,
        bounce_rate: 0.11,
        behavior_date: "2023-01-26",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1280,
        click_count: 390,
        duration: 210.5,
        bounce_rate: 0.16,
        behavior_date: "2023-01-27",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 920,
        click_count: 290,
        duration: 170.8,
        bounce_rate: 0.17,
        behavior_date: "2023-01-28",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "平板",
      },
      {
        page_views: 1620,
        click_count: 510,
        duration: 275.2,
        bounce_rate: 0.1,
        behavior_date: "2023-01-29",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1380,
        click_count: 420,
        duration: 225.7,
        bounce_rate: 0.13,
        behavior_date: "2023-01-30",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
      },
      {
        page_views: 1050,
        click_count: 320,
        duration: 185.4,
        bounce_rate: 0.2,
        behavior_date: "2023-01-31",
        user_segment: "老用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "平板",
      },
      {
        page_views: 1890,
        click_count: 600,
        duration: 305.1,
        bounce_rate: 0.08,
        behavior_date: "2023-02-01",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1150,
        click_count: 350,
        duration: 200.3,
        bounce_rate: 0.15,
        behavior_date: "2023-02-02",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
      },
    ],
  },
  x: 0,
  y: 0,
  w: 12,
  h: 8,
  i: "0",
  originCol: 12,
  originWidth: 12,
  _select: true,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
  styleConfig: {
    commongConfig: {
      showTitle: false,
      showRemark: false,
      remark: "",
      remarkPosition: 1,
      backgroundColor: "#fff",
      mergeCells: false,
      pagination: true,
    },
  },
};

const aa = [];

export const columnWidgets = {
  id: "123",
  type: "Column",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "柱图22",
  measures: [
    {
      unitCode: "page_views",
      unitName: "页面浏览量",
      belongDimName: null,
    },
    {
      unitCode: "click_count",
      unitName: "点击次数",
      belongDimName: null,
    },
    {
      unitCode: "duration",
      unitName: "停留时长",
      belongDimName: null,
    },
    {
      unitCode: "bounce_rate",
      unitName: "跳出率",
      belongDimName: null,
    },
  ],
  dimensions: [
    {
      unitCode: "behavior_date",
      unitName: "行为日期",
      belongDimName: null,
    },
    {
      unitCode: "behavior_hour",
      unitName: "行为小时",
      belongDimName: null,
    },
    {
      unitCode: "behavior_type",
      unitName: "行为类型",
      belongDimName: null,
    },
    {
      unitCode: "page_type",
      unitName: "页面类型",
      belongDimName: null,
    },
    {
      unitCode: "device_type",
      unitName: "设备类型",
      belongDimName: null,
    },
    {
      unitCode: "user_segment",
      unitName: "用户细分",
      belongDimName: null,
    },
    {
      unitCode: "user_level",
      unitName: "用户等级",
      belongDimName: null,
    },
    {
      unitCode: "user_id",
      unitName: "用户ID",
      belongDimName: null,
    },
    {
      unitCode: "session_id",
      unitName: "会话ID",
      belongDimName: null,
    },
  ],
  defaultCols: "half",
  className: "component-type-bar",
  defaultImg: "http://172.31.29.180:3000/static/img/column-none.a609dd.png",
  fields: [
    {
      label: "类别轴/维度",
      isMust: true,
      limitNum: null,
      type: "dimension",
      alias: "dimension",
      queryType: "rows",
      chooseFields: [
        {
          unitCode: "user_level",
          unitName: "用户等级",
          belongDimName: null,
          id: "user_level_0",
          name: "用户等级",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
      ],
    },
    {
      label: "值轴/度量",
      isMust: true,
      limitNum: null,
      type: "measure",
      alias: "measure",
      queryType: "values",
      chooseFields: [
        {
          unitCode: "page_views",
          unitName: "页面浏览量",
          belongDimName: null,
          id: "page_views_0",
          name: "页面浏览量",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          alias: "measure",
          queryType: "values",
        },
      ],
    },
    {
      label: "颜色图例/维度",
      isMust: false,
      limitNum: 1,
      type: "dimension",
      alias: "dimension",
      queryType: "columns",
      chooseFields: [
        {
          unitCode: "behavior_date",
          unitName: "行为日期",
          belongDimName: null,
          id: "behavior_date_0",
          name: "行为日期",
          originIdx: 2,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "columns",
        },
      ],
    },
  ],
  styleComp: {
    type: "c-column-style",
    styleConfig: {},
  },
  _id: "id_17580866542893",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    meta: [
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
    ],
    data: [
      {
        page_views: 63,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
        xField: "普通",
        yField: 63,
        seriesField: "2023-01-15",
      },
      {
        page_views: 45,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "点击",
        device_type: "移动端",
        xField: "VIP",
        yField: 45,
        seriesField: "2023-01-16",
      },
      {
        page_views: 73,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
        xField: "高级",
        yField: 73,
        seriesField: "2023-01-17",
      },
      {
        page_views: 41,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
        xField: "普通",
        yField: 41,
        seriesField: "2023-01-18",
      },
      {
        page_views: 69,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
        xField: "VIP",
        yField: 69,
        seriesField: "2023-01-19",
      },
      {
        page_views: 60,
        click_count: 380,
        duration: 220.7,
        bounce_rate: 0.12,
        behavior_date: "2023-01-20",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
        xField: "普通",
        yField: 60,
        seriesField: "2023-01-20",
      },
      {
        page_views: 48,
        click_count: 520,
        duration: 280.4,
        bounce_rate: 0.09,
        behavior_date: "2023-01-21",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "移动端",
        xField: "高级",
        yField: 48,
        seriesField: "2023-01-21",
      },
      {
        page_views: 26,
        click_count: 340,
        duration: 195.2,
        bounce_rate: 0.21,
        behavior_date: "2023-01-22",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "平板",
        xField: "普通",
        yField: 26,
        seriesField: "2023-01-22",
      },
      {
        page_views: 23,
        click_count: 620,
        duration: 310.8,
        bounce_rate: 0.07,
        behavior_date: "2023-01-23",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "购买",
        device_type: "PC",
        xField: "VIP",
        yField: 23,
        seriesField: "2023-01-23",
      },
      {
        page_views: 37,
        click_count: 410,
        duration: 240.6,
        bounce_rate: 0.14,
        behavior_date: "2023-01-24",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
        xField: "普通",
        yField: 37,
        seriesField: "2023-01-24",
      },
      {
        page_views: 45,
        click_count: 260,
        duration: 155.9,
        bounce_rate: 0.19,
        behavior_date: "2023-01-25",
        user_segment: "老用户",
        user_level: "普通",
        behavior_type: "搜索",
        device_type: "平板",
        xField: "普通",
        yField: 45,
        seriesField: "2023-01-25",
      },
      {
        page_views: 29,
        click_count: 580,
        duration: 295.3,
        bounce_rate: 0.11,
        behavior_date: "2023-01-26",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
        xField: "高级",
        yField: 29,
        seriesField: "2023-01-26",
      },
      {
        page_views: 66,
        click_count: 390,
        duration: 210.5,
        bounce_rate: 0.16,
        behavior_date: "2023-01-27",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "移动端",
        xField: "普通",
        yField: 66,
        seriesField: "2023-01-27",
      },
      {
        page_views: 33,
        click_count: 290,
        duration: 170.8,
        bounce_rate: 0.17,
        behavior_date: "2023-01-28",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "平板",
        xField: "VIP",
        yField: 33,
        seriesField: "2023-01-28",
      },
      {
        page_views: 96,
        click_count: 510,
        duration: 275.2,
        bounce_rate: 0.1,
        behavior_date: "2023-01-29",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
        xField: "高级",
        yField: 96,
        seriesField: "2023-01-29",
      },
      {
        page_views: 29,
        click_count: 420,
        duration: 225.7,
        bounce_rate: 0.13,
        behavior_date: "2023-01-30",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
        xField: "普通",
        yField: 29,
        seriesField: "2023-01-30",
      },
      {
        page_views: 93,
        click_count: 320,
        duration: 185.4,
        bounce_rate: 0.2,
        behavior_date: "2023-01-31",
        user_segment: "老用户",
        user_level: "普通",
        behavior_type: "点击",
        device_type: "平板",
        xField: "普通",
        yField: 93,
        seriesField: "2023-01-31",
      },
      {
        page_views: 39,
        click_count: 600,
        duration: 305.1,
        bounce_rate: 0.08,
        behavior_date: "2023-02-01",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "购买",
        device_type: "PC",
        xField: "VIP",
        yField: 39,
        seriesField: "2023-02-01",
      },
      {
        page_views: 42,
        click_count: 350,
        duration: 200.3,
        bounce_rate: 0.15,
        behavior_date: "2023-02-02",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "移动端",
        xField: "普通",
        yField: 42,
        seriesField: "2023-02-02",
      },
    ],
  },
  x: 0,
  y: 0,
  w: 6,
  h: 8,
  i: "1",
  originCol: 12,
  originWidth: 6,
  _select: false,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
  styleConfig: {
    commongConfig: {
      showTitle: true,
      showRemark: true,
      remark: "323",
      remarkPosition: 1,
      backgroundColor: "rgba(248, 3, 3, 1)",
      mergeCells: false,
      pagination: false,
      indicatorIcon: false,
      indicatorStyle: 1,
      columnBackgroundOpacity: 100,
      gradientEffect: true,
      columnWidthRatio: 100,
      labelConfig: {
        show: true,
        showAll: true,
        position: "top",
        textConfig: {
          fontSize: 15,
          isBold: true,
          color: "#B305E8",
          isItalic: true,
        },
      },
      legendConfig: {
        show: true,
        position: "left",
      },
      customBackgroundColor: false,
    },
    helperData: {
      indicatorRowIconMap: {},
      fieldMap: {
        "2023-01-15": {
          w_text: "2023-01-15",
          w_seriesColor: "#5B8FF9",
        },
        "2023-01-16": {
          w_text: "2023-01-16",
          w_seriesColor: "#BDD2FD",
        },
        "2023-01-17": {
          w_text: "2023-01-17",
          w_seriesColor: "#61DDAA",
        },
        "2023-01-18": {
          w_text: "2023-01-18",
          w_seriesColor: "#BDEFDB",
        },
        "2023-01-19": {
          w_text: "2023-01-19",
          w_seriesColor: "#BDEFDB",
        },
        "2023-01-20": {
          w_text: "2023-01-20",
          w_seriesColor: "#C2C8D5",
        },
        "2023-01-21": {
          w_text: "2023-01-21",
          w_seriesColor: "#F6BD16",
        },
        "2023-01-22": {
          w_text: "2023-01-22",
          w_seriesColor: "#FBE5A2",
        },
        "2023-01-23": {
          w_text: "2023-01-23",
          w_seriesColor: "#7262FD",
        },
        "2023-01-24": {
          w_text: "2023-01-24",
          w_seriesColor: "#D3CEFD",
        },
        "2023-01-25": {
          w_text: "2023-01-25",
          w_seriesColor: "#78D3F8",
        },
        "2023-01-26": {
          w_text: "2023-01-26",
          w_seriesColor: "#B6E3F5",
        },
        "2023-01-27": {
          w_text: "2023-01-27",
          w_seriesColor: "#9661BC",
        },
        "2023-01-28": {
          w_text: "2023-01-28",
          w_seriesColor: "#D3C6EA",
        },
        "2023-01-29": {
          w_text: "2023-01-29",
          w_seriesColor: "#FFD8B8",
        },
        "2023-01-30": {
          w_text: "2023-01-30",
          w_seriesColor: "#008685",
        },
        "2023-01-31": {
          w_text: "2023-01-31",
          w_seriesColor: "#AAD8D8",
        },
        "2023-02-01": {
          w_text: "2023-02-01",
          w_seriesColor: "#F08BB4",
        },
        "2023-02-02": {
          w_text: "2023-02-02",
          w_seriesColor: "#FFD6E7",
        },
      },
      nameMap: {
        user_level: "用户等级",
        page_views: "页面浏览量",
        behavior_date: "行为日期",
      },
    },
  },
};

export const pieWidgets = {
  type: "Pie",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "饼图",
  measures,
  dimensions,
  defaultCols: "half",
  className: "component-type-pie",
  defaultImg: "http://172.31.29.180:3000/static/img/pie-none.3cb81d.png",
  fields: [
    {
      label: "扇区标签/维度",
      isMust: true,
      limitNum: 1,
      type: "dimension",
      queryType: "rows",
      chooseFields: [
        {
          unitCode: "behavior_type",
          unitName: "行为类型",
          belongDimName: null,
          id: "behavior_type_0",
          name: "行为类型",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          queryType: "rows",
        },
      ],
    },
    {
      label: "扇区角度/度量",
      isMust: true,
      limitNum: 10,
      type: "measure",
      queryType: "columns",
      chooseFields: [
        {
          unitCode: "click_count",
          unitName: "点击次数",
          belongDimName: null,
          id: "click_count_0",
          name: "点击次数",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          queryType: "columns",
        },
      ],
    },
  ],
  styleComp: {
    type: "c-pie-style",
    styleConfig: {},
  },
  _id: "id_1757314937506",
  dataSetId: "USER_BEHAVIOR_FACT",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    fields: {
      rows: ["behavior_date", "user_segment", "user_level"],
      columns: ["behavior_type", "device_type"],
      values: ["page_views", "click_count", "duration", "bounce_rate"],
      valueInCols: true,
    },
    meta: [
      {
        field: "page_views",
        name: "页面浏览量",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
      {
        field: "duration",
        name: "停留时长",
      },
      {
        field: "bounce_rate",
        name: "跳出率",
      },
      {
        field: "behavior_date",
        name: "行为日期",
      },
      {
        field: "user_segment",
        name: "用户分群",
      },
      {
        field: "user_level",
        name: "用户等级",
      },
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "device_type",
        name: "设备类型",
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
      },
    ],
  },
  x: 6,
  y: 0,
  w: 6,
  h: 8,
  i: "2",
  originCol: 12,
  originWidth: 6,
  _select: false,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
};

export const indicatorWidgets = {
  type: "Indicator",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "指标卡",
  measures,
  dimensions,
  defaultCols: "half",
  className: "component-type-indicator-card",
  defaultImg: "http://172.31.29.180:3000/static/img/indicator-card.b7982b.png",
  fields: [
    {
      label: "看板标签/维度",
      isMust: false,
      limitNum: 1,
      type: "dimension",
      alias: "dimension",
      queryType: "rows",
      chooseFields: [
        {
          unitCode: "device_type",
          unitName: "设备类型",
          belongDimName: null,
          id: "device_type_0",
          name: "设备类型",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
      ],
    },
    {
      label: "看板指标/度量",
      isMust: true,
      limitNum: null,
      type: "measure",
      alias: "measure",
      queryType: "values",
      chooseFields: [
        {
          unitCode: "page_views",
          unitName: "页面浏览量",
          belongDimName: null,
          id: "page_views_0",
          name: "页面浏览量",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          alias: "measure",
          queryType: "values",
        },
      ],
    },
  ],
  styleComp: {
    type: "c-indicator-style",
    styleConfig: {},
  },
  _id: "id_1757569952453",
  dataSetId: "USER_BEHAVIOR_FACT",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    fields: {
      rows: ["behavior_date", "user_segment", "user_level"],
      columns: ["behavior_type", "device_type"],
      values: ["page_views", "click_count", "duration", "bounce_rate"],
      valueInCols: true,
    },
    meta: [
      {
        field: "page_views",
        name: "页面浏览量",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
      {
        field: "duration",
        name: "停留时长",
      },
      {
        field: "bounce_rate",
        name: "跳出率",
      },
      {
        field: "behavior_date",
        name: "行为日期",
      },
      {
        field: "user_segment",
        name: "用户分群",
      },
      {
        field: "user_level",
        name: "用户等级",
      },
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "device_type",
        name: "设备类型",
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "SVIP",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
      },
    ],
  },
  x: 3,
  y: 0,
  w: 6,
  h: 8,
  i: "0",
  originCol: 12,
  originWidth: 6,
  _select: true,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
  styleConfig: {
    helperData: {
      indicatorRowIconMap: {},
    },
    commongConfig: {
      showTitle: false,
      showRemark: false,
      remark: "",
      remarkPosition: 1,
      backgroundColor: "#fff",
      mergeCells: false,
      pagination: false,
      indicatorIcon: false,
      indicatorStyle: 1,
    },
  },
};

export const lineWidgets = {
  type: "Line",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "折线图",
  measures,
  dimensions,
  defaultCols: "half",
  className: "component-type-line",
  defaultImg: "http://172.31.29.180:3000/static/img/line-none.5b0a59.png",
  fields: [
    {
      label: "类别轴/维度",
      isMust: true,
      limitNum: null,
      type: "dimension",
      alias: "dimension",
      queryType: "rows",
      chooseFields: [
        {
          unitCode: "behavior_date",
          unitName: "行为日期",
          belongDimName: null,
          id: "behavior_date_0",
          name: "行为日期",
          originIdx: 0,
          defineType: "dimension",
          originType: "dimension",
          alias: "dimension",
          queryType: "rows",
        },
      ],
    },
    {
      label: "值轴/度量",
      isMust: true,
      limitNum: null,
      type: "measure",
      alias: "measure",
      queryType: "values",
      chooseFields: [
        {
          unitCode: "click_count",
          unitName: "点击次数",
          belongDimName: null,
          id: "click_count_0",
          name: "点击次数",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          alias: "measure",
          queryType: "values",
        },
        {
          unitCode: "page_views",
          unitName: "页面浏览量",
          belongDimName: null,
          id: "page_views_1",
          name: "页面浏览量",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          alias: "measure",
          queryType: "values",
        },
      ],
    },
    {
      label: "颜色图例/维度",
      isMust: false,
      limitNum: 1,
      type: "dimension",
      alias: "dimension",
      queryType: "columns",
      chooseFields: [],
    },
  ],
  styleComp: {
    type: "c-line-style",
    styleConfig: {},
  },
  _id: "id_1757314952994",
  dataSetId: "USER_BEHAVIOR_FACT",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    fields: {
      rows: ["behavior_date", "user_segment", "user_level"],
      columns: ["behavior_type", "device_type"],
      values: ["page_views", "click_count", "duration", "bounce_rate"],
      valueInCols: true,
    },
    meta: [
      {
        field: "page_views",
        name: "页面浏览量",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
      {
        field: "duration",
        name: "停留时长",
      },
      {
        field: "bounce_rate",
        name: "跳出率",
      },
      {
        field: "behavior_date",
        name: "行为日期",
      },
      {
        field: "user_segment",
        name: "用户分群",
      },
      {
        field: "user_level",
        name: "用户等级",
      },
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "device_type",
        name: "设备类型",
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 321,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
      },
    ],
  },
  x: 6,
  y: 8,
  w: 6,
  h: 8,
  i: "4",
  originCol: 12,
  originWidth: 6,
  _select: true,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
};

export const gaugeWidgets = {
  type: "Gauge",
  defaultRows: 8,
  dataSetId: "USER_BEHAVIOR_FACT",
  dataSetName: "用户行为事实表",
  name: "仪表盘",
  measures,
  dimensions,
  defaultCols: "half",
  className: "component-type-gauge",
  defaultImg: "http://172.31.29.180:3000/static/img/gauge-none.3cb81d.png",
  fields: [
    {
      label: "指针角度/度量",
      isMust: true,
      limitNum: 10,
      type: "measure",
      queryType: "columns",
      chooseFields: [
        {
          unitCode: "click_count",
          unitName: "点击次数",
          belongDimName: null,
          id: "click_count_0",
          name: "点击次数",
          originIdx: 1,
          aggregatorType: "avg",
          defineType: "measure",
          originType: "measure",
          queryType: "columns",
        },
      ],
    },
  ],
  styleComp: {
    type: "c-pie-style",
    styleConfig: {},
  },
  _id: "id_1757314937506",
  dataSetId: "USER_BEHAVIOR_FACT",
  data: {
    describe:
      "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
    fields: {
      rows: ["behavior_date", "user_segment", "user_level"],
      columns: ["behavior_type", "device_type"],
      values: ["page_views", "click_count", "duration", "bounce_rate"],
      valueInCols: true,
    },
    meta: [
      {
        field: "page_views",
        name: "页面浏览量",
      },
      {
        field: "click_count",
        name: "点击次数",
      },
      {
        field: "duration",
        name: "停留时长",
      },
      {
        field: "bounce_rate",
        name: "跳出率",
      },
      {
        field: "behavior_date",
        name: "行为日期",
      },
      {
        field: "user_segment",
        name: "用户分群",
      },
      {
        field: "user_level",
        name: "用户等级",
      },
      {
        field: "behavior_type",
        name: "行为类型",
      },
      {
        field: "device_type",
        name: "设备类型",
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: "2023-01-15",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "PC",
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: "2023-01-16",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "点击",
        device_type: "移动端",
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: "2023-01-17",
        user_segment: "老用户",
        user_level: "高级",
        behavior_type: "购买",
        device_type: "PC",
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: "2023-01-18",
        user_segment: "新用户",
        user_level: "普通",
        behavior_type: "浏览",
        device_type: "平板",
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: "2023-01-19",
        user_segment: "老用户",
        user_level: "VIP",
        behavior_type: "搜索",
        device_type: "移动端",
      },
    ],
  },
  x: 6,
  y: 0,
  w: 6,
  h: 8,
  i: "2",
  originCol: 12,
  originWidth: 6,
  _select: false,
  moved: false,
  describe:
    "用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标",
  describeShow: false,
};

export const widgets = [
  tableWidgets,
  columnWidgets,
  pieWidgets,
  indicatorWidgets,
  lineWidgets,
];
